<div class="get-care-now-title-container-mobile">{{title}}</div>
<div class="get-care-now-description-container-mobile">
    <div>{{description}}</div>
</div>
<div *ngIf="primaryCareProviderOptions != null && primaryCareProviderOptions.length > 0"  class="get-care-now-scroll-container-mobile">
    <app-primary-care-provider-option-card-mobile
        *ngFor="let option of primaryCareProviderOptions; let i = index"
        [providerId]="option.providerId"
        [departmentId]="option.departmentId"
        [name]="option.providerName"
        [specialties]="option.specialties"
        [city]="option.city"
        [phone]="option.phone"
        [photo]="option.photo"
        [isPcp]="option.isPcp"
        [availability]="option.nextAvailability"
        [distance]="option.distanceInMiles"
        [specialtyId]="option.specialtyId"
        [locale]="locale"
        [pcpId]="pcpId"
        [isOpenScheduling]="option.isOpenScheduling"
        [ngStyle]="i === 0 ? {'margin-left': '16px'} : null">
    </app-primary-care-provider-option-card-mobile>
    <div>
        <mat-card class="get-care-now-show-more-card-mobile" appearance="outlined" style="text-align: center;" (click)="showMeMore()">
            <div class="get-care-now-show-more-button-mobile">{{showMoreText}}</div>
        </mat-card>
    </div>
</div>
<div *ngIf="!primaryCareProviderOptions || primaryCareProviderOptions.length === 0" style="width: 190px; height:190px; margin-top: 16px; margin-left: 16px;">
    <ng-container>
        <div class="get-care-now-loading-spinner-mobile">
            <mat-spinner></mat-spinner>
        </div>
    </ng-container>
</div>